
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class ProductoService {
    private url : string = `${environment.HOST}/api/producto`;
    private urlUpload : string = `${environment.HOST}/api`;
  


    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

      guardarImagenPortada(form:FormData,tipoMedia:number ) {
        return this.http.post(`${this.urlUpload}/media/upload/${tipoMedia}`,form);
      }
    
      
    
  nuevoProducto(  idUsuario : number, modelo : string,descripcion : string,detalles : string,idCategoria : number,idMarca : number,precio :number,imagen:String,colortalla:String,imagen2:String,imagen3:String,precio2:number,altura:String,idEstado:number,limitarExistencia:String) {
    return this.http.post(`${this.url}/nuevo-producto/${idUsuario}/${modelo}/${descripcion}/${detalles}/${idCategoria}/${idMarca}/${precio}/${imagen}/${colortalla}/${imagen2}/${imagen3}/${precio2}/${altura}/${idEstado}/${limitarExistencia}`, "");
  }

 modificaProducto( idUsuario : number,idProducto:number, modelo : string,descripcion : string,detalles : string,idCategoria : number,idMarca : number,precio :number,imagen:String,colortalla:String,imagen2:String,imagen3:String,precio2:number,altura:String,idEstado:number,productorel:String,limitarExistencia:String) {
    return this.http.post(`${this.url}/modifica-producto/${idUsuario}/${idProducto}/${modelo}/${descripcion}/${detalles}/${idCategoria}/${idMarca}/${precio}/${imagen}/${colortalla}/${imagen2}/${imagen3}/${precio2}/${altura}/${idEstado}/${productorel}/${limitarExistencia}`, "");
  }

 anulaProducto( idUsuario : number,idProducto:number) {
    return this.http.post(`${this.url}/anula-producto/${idUsuario}/${idProducto}`, "");
  }



    }